import React from 'react'
import IMAGES from '../../images'
import { MaintainText, MaintainWrapper } from './MaintainStyled'
import { Container } from '../CommonStyled/CommonStyled'

const Maintain = () => {
  return (
    <MaintainWrapper>
      <img className={'maintain'} src={IMAGES.MAINTAIN} alt="maintain" />
      <br/>
      <MaintainText>Trang hiện đang tạm dừng hoạt động.</MaintainText>
      <MaintainText>Quý khách vui lòng quay trở lại sau!</MaintainText>
    </MaintainWrapper>
  )
}

export default Maintain